import { TableCell, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/ui/components/skeleton/skeleton';

export function ContractsTableSkeletonRow() {
  return (
    <TableRow>
      <TableCell className="!pl-3">
        <Skeleton className="h-4 w-32" />
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          <Skeleton className="size-4" />
          <Skeleton className="h-4 w-24" />
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          <Skeleton className="size-4" />
          <Skeleton className="h-4 w-24" />
        </div>
      </TableCell>
      <TableCell className="!pr-3">
        <Skeleton className="h-6 w-16" />
      </TableCell>
    </TableRow>
  );
}
